import jwt from 'jsonwebtoken';

/*

    EXAMPLE:
    let data = {
        
    };
    send(data, this.props.socket);

*/

function send(data, socket, token){
    data.token = token;
    let command = jwt.sign({command: data}, '#&r7%+UbWU8Hc');
    if(process.env.NODE_ENV == "development"){
        // console.log("SENDING >>", command, "\n", data, "\n", "socket: ", socket, "\n");
    }
    socket.send(command);
}

export default send;


// WEBPACK FOOTER //
// ./src/utils/ChatServer.js